/* eslint-disable import/prefer-default-export */
import { useMemo } from 'react';
import { calculateLineItemTotal, hasDiscount } from '../utils/lineItemUtils';

export const useLineItemTotal = (product) => useMemo(() => {
  const { total = 0, total_discount = 0 } = product;

  const finalTotal = calculateLineItemTotal(total, total_discount);

  return {
    total,
    totalDiscount: total_discount,
    finalTotal,
    hasDiscount: hasDiscount(total_discount)
  };
}, [product]);
